import { MasterCustomer } from "./master-customer";

export class MasterCustomerRechargeRenew {
  constructor() {
    this.CUSTOMER_RECHARGE_RENEW_ID = 0;
    this.CUSTOMER_ID = 0;
    this.PROFILE_ID = 0;
    this.RECHARGE_RENEW_SALE_AMOUNT = 0;
    this.RECHARGE_RENEW_CREDITED_AMOUNT = 0;
    this.RECHARGE_DISCOUNT_ID = 0;
    this.RECHARGE_RENEW_FROM = '';
    this.RECHARGE_RENEW_TO = '';
    this.RECHARGE_RENEW_RECEIPT = false;
    this.RECHARGE_RENEW_FISCAL_RECEIPT = false;
    this.ENTRY_USER = 0;
    this.ADMINISTRATIVE_SALE_PRICE = 0;
  }
  CUSTOMER_RECHARGE_RENEW_ID: number;
  CUSTOMER_ID: number;
  PROFILE_ID: number;
  RECHARGE_RENEW_SALE_AMOUNT: number;
  RECHARGE_RENEW_CREDITED_AMOUNT: number;
  RECHARGE_DISCOUNT_ID: number;
  RECHARGE_RENEW_FROM: string;
  RECHARGE_RENEW_TO: string;
  RECHARGE_RENEW_RECEIPT: boolean;
  RECHARGE_RENEW_FISCAL_RECEIPT: boolean;
  ENTRY_USER: number;

  ADMINISTRATIVE_SALE_PRICE: number;
  TOTAL_AMOUNT: number;
  CGST_AMOUNT: number;
  IGST_AMOUNT: number;
  NET_AMOUNT: number;

  PAYTYPE_ID: number;
}
